import { AlloyButton, Modal, useModal } from 'cat-ecommerce-alloy';
import styles from './WarrantyAndPolicyLinks.module.scss';
import { useTranslation } from 'react-i18next';
import WarrantyModalContent from '@app/components/common/WarrantyModalContent';
import ReturnPolicyModalContent from '@app/components/common/ReturnPolicyModalContent';

const WarrantyAndPolicyLinks = () => {
  const { t } = useTranslation();
  const warrantyModalProps = useModal();
  const returnPolicyModalProps = useModal();

  return (
    <section
      className={`d-flex d-print-none flex-column flex-md-row mx-0 mt-4 mt-md-3 pt-3 pt-lg-1 mt-lg-0`}
    >
      <AlloyButton
        buttonType="ghost"
        size="dynamic"
        onClick={warrantyModalProps.open}
        className="px-0 py-2 mt-1 mt-md-0 text-nowrap"
      >
        {`${t('WARRANTY_INFO')}`}
      </AlloyButton>
      <hr
        className={`${styles['warranty-and-policy-buttons__hr']} d-none d-md-inline-block mx-4 my-0`}
      />
      <AlloyButton
        buttonType="ghost"
        size="dynamic"
        onClick={returnPolicyModalProps.open}
        className="px-0 py-2 mt-1 mt-md-0 text-nowrap"
      >
        {`${t('RETURN_POLICY_VIEW')}`}
      </AlloyButton>
      <Modal
        close={warrantyModalProps.close}
        isOpen={warrantyModalProps.isOpen}
      >
        <WarrantyModalContent />
      </Modal>
      <Modal
        close={returnPolicyModalProps.close}
        isOpen={returnPolicyModalProps.isOpen}
      >
        <ReturnPolicyModalContent />
      </Modal>
    </section>
  );
};

export default WarrantyAndPolicyLinks;
